import { reactive } from "vue";
const DEFAULT_USER = {
    id: "mock-user-1",
    email: "test@example.com",
    name: "Test User",
};
export class MockAuthProvider {
    name = "mock";
    state;
    storageKey;
    user;
    constructor(opts) {
        this.storageKey = opts.storageKey;
        this.user = opts.user ?? DEFAULT_USER;
        this.state = reactive({
            status: "idle",
            user: null,
            idToken: null,
            accessToken: null,
            error: null,
        });
        if (opts.autoLogin) {
            this.persist(this.user);
        }
    }
    async init() {
        this.state.status = "initializing";
        const stored = this.read();
        this.state.user = stored;
        this.state.idToken = null;
        this.state.accessToken = null;
        this.state.status = stored ? "authenticated" : "unauthenticated";
    }
    async login() {
        this.persist(this.user);
        this.state.user = this.user;
        this.state.idToken = null;
        this.state.accessToken = null;
        this.state.status = "authenticated";
        this.state.error = null;
    }
    async logout() {
        sessionStorage.removeItem(this.storageKey);
        this.state.user = null;
        this.state.idToken = null;
        this.state.accessToken = null;
        this.state.status = "unauthenticated";
    }
    persist(user) {
        sessionStorage.setItem(this.storageKey, JSON.stringify(user));
    }
    read() {
        const raw = sessionStorage.getItem(this.storageKey);
        if (!raw)
            return null;
        try {
            return JSON.parse(raw);
        }
        catch {
            return null;
        }
    }
}
//# sourceMappingURL=mock.js.map